import { useQuery } from "@tanstack/react-query";
import { authedFetch, hasStoredSession, useStoredAuth } from "nazare-ui/utils";

import { resolveBffDomain } from "./bff-domain";
import { exclusiveEndDate, type InboxAnalyticsUrlState } from "./inbox-analytics-url-state";

export type InboxAnalyticsBucket = {
  bucketStart: string;
  gmail: number;
  legacy: number;
  matched: number;
  missingFromGmail: number;
  gmailOnly: number;
};
export type InboxAnalyticsInbox = {
  inboxId: string;
  inboxName: string;
  totals: {
    gmail: number;
    legacy: number;
    matched: number;
    missingFromGmail: number;
    gmailOnly: number;
  };
  buckets: InboxAnalyticsBucket[];
};
export type InboxAnalyticsResponse = { inboxes: InboxAnalyticsInbox[] };

const BASE = `${resolveBffDomain()}/inboxes`;

export function useInboxAnalytics(filters: InboxAnalyticsUrlState) {
  const auth = useStoredAuth();
  return useQuery({
    queryKey: ["inboxes", "analytics", filters],
    enabled: hasStoredSession(auth),
    queryFn: async ({ signal }) => {
      const params = new URLSearchParams({ from: filters.from, to: exclusiveEndDate(filters.to), granularity: filters.granularity });
      const response = await authedFetch(BASE, auth, `/analytics?${params}`, { signal });
      if (!response.ok) throw new Error(`Failed to fetch inbox analytics: ${response.status}`);
      return response.json() as Promise<InboxAnalyticsResponse>;
    },
    staleTime: 30_000,
  });
}
